/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, {
  useRef,
  useMemo,
  useContext,
  createContext,
  useEffect,
} from "react";
import { useGLTF, Merged } from "@react-three/drei";
import * as THREE from "three";
import useStore from "../../stores/store";

const S3_BUCKET_URL = "https://site-davidbickley.s3.us-east-2.amazonaws.com";

const context = createContext();

export function Chamber(props) {
  const { nodes } = useGLTF(`${S3_BUCKET_URL}/models/dbSiteLandscape.glb`);
  const { theme } = useStore();

  const material = new THREE.MeshStandardMaterial({
    color: theme.bodyBgPrimary,
    roughness: 0.25,
    metalness: 1,
  });

  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[12.85, -0.05, -5.8]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={[42.219, 11.938, 2.625]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[8.8, -0.05, -27.35]}
        scale={[38.344, 13.063, 12.188]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-8.95, 12.45, -24.35]}
        rotation={[-Math.PI / 2, 0, Math.PI]}
        scale={[13.875, 16.844, 8.875]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[5.75, 12.143, -25.55]}
        rotation={[-Math.PI / 2, 0, 1.745]}
        scale={[14.406, 9.875, 11.75]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[9.05, 9.15, 28.25]}
        rotation={[Math.PI / 2, 0, -Math.PI]}
        scale={[22, 11.688, 5.938]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-10.4, 8.999, 23.2]}
        rotation={[Math.PI / 2, 0, -Math.PI / 2]}
        scale={[23.188, 11.5, 5.938]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-12.35, -0.05, -13.65]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={[47.313, 11.656, 7.906]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[9.6, 11.6, -24.1]}
        rotation={[-Math.PI / 2, 0, Math.PI]}
        scale={[13.875, 16.844, 12.406]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[0.7, 10.769, 19.4]}
        rotation={[Math.PI / 2, 0, Math.PI]}
        scale={[56.844, 6.188, 8.813]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[13.45, -0.05, 10.85]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={[53.5, 8.625, 2.625]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-11.95, -0.05, 5.5]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[53.5, 9.063, 2.625]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-8.35, 12.45, 15.35]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[13.875, 18.75, 8.875]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[11, 11.25, 15.35]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[13.875, 18.75, 8.844]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-8.95, -0.1, 15.6]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[12.719, 18.75, 2.625]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-11.6, 0.55, 15.6]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[12.719, 18.75, 2.625]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[12.35, -0.1, 17.05]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[12.719, 18.75, 2.625]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[12.55, 0.35, 17.2]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[-8, 18.75, 2.625]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[13.65, -0.15, -5.9]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[12.719, 18.75, 2.625]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-10.75, -0.2, -5.45]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[12.719, 18.75, 2.625]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[3.1, 0, -24.2]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[52.781, 8.438, 2.625]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[1.8, -0.15, -2.001]}
        rotation={[3.126, -1.047, 3.129]}
        scale={[8.031, 0.688, 8.563]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[8.65, 0.05, -2.601]}
        rotation={[0.008, 0.087, 0]}
        scale={[2.25, 9.438, 2.438]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-6.45, 0.05, -2.601]}
        rotation={[0.087, -1.484, 0.087]}
        scale={[2.25, 9.969, 2.437]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[7.35, 12.143, 5.2]}
        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
        scale={[21.75, 15.187, 11.75]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-5.25, 0.05, 6.749]}
        rotation={[0.087, -1.484, 0.087]}
        scale={[2.25, 9.969, 2.437]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-6.05, -0.1, -14.151]}
        rotation={[0.087, -1.484, 0.087]}
        scale={[2.25, 9.969, 2.437]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[8.6, 0, -13.601]}
        rotation={[0.087, -1.484, 0.087]}
        scale={[2.25, 9.969, 2.437]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-10.6, 11.05, -15.45]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[13.875, 16.844, 8.875]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-6.2, 18.7, 0.85]}
        rotation={[-Math.PI / 2, 0, -0.087]}
        scale={[13.875, 24.156, 24.156]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-5.85, 18.7, -19.65]}
        rotation={[-Math.PI / 2, 0, -1.658]}
        scale={[13.875, 16.844, 24.844]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[21.15, -0.05, -11.45]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={[42.219, 11.938, 7.563]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[8.05, 19.75, -19.65]}
        rotation={[-Math.PI / 2, 0, Math.PI]}
        scale={[13.875, 16.844, 24.844]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-17.35, -0.05, -78.95]}
        scale={[85.656, 23.219, 9.938]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-40.85, -0.05, -59.6]}
        rotation={[0, 1.484, 0]}
        scale={[92.031, 23.219, 9.938]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-23.3, 17.25, -73]}
        rotation={[-Math.PI / 2, 0, Math.PI]}
        scale={[50.688, 53.656, 7.25]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-40.85, -0.05, -21.15]}
        rotation={[0, 1.484, 0]}
        scale={[92.031, 23.219, 9.938]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[11.45, -0.05, -60.25]}
        rotation={[0, 1.484, 0]}
        scale={[92.031, 35.031, 9.938]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-10.45, -0.05, -57.85]}
        rotation={[-Math.PI, 0.087, -Math.PI]}
        scale={[5.156, 13.719, 7.781]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-24.65, -0.05, -57.85]}
        rotation={[0, 1.484, 0]}
        scale={[5.844, 15, 8.469]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-10.45, -0.05, -46.75]}
        rotation={[-Math.PI, 0.087, -Math.PI]}
        scale={[5.156, 13.719, 7.781]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-24.65, -0.05, -46.75]}
        rotation={[0, 1.484, 0]}
        scale={[5.844, 15, 8.469]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-0.75, -0.75, 15.6]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[48.75, 33, 2.938]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.SM_Env_Rock_010.geometry}
        material={material}
        position={[-13.4, -0.75, -28.8]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[73.438, 74.313, 2.938]}
      />
    </group>
  );
}

useGLTF.preload(`${S3_BUCKET_URL}/models/dbSiteLandscape.glb`);
